module.exports = __webpack_public_path__ + "media/images/ir/top/bg_mainimg-07f2b832365c95c2ebf50c5cac50a6c4.png";